import { ModelBase } from '../../core/model/model-base';
import { TenantCategory } from './const/enums';
import { ContactIdKind } from './contact';

export class RentApplicationContact extends ModelBase {
  constructor() {
    super();
  }

  public contactEmail: string;
  public contactPhone: string;
  public contactCategory: TenantCategory;
  public contactCustomerNumber: number;
  public contactName: string;
  public contactIdentification: string;
  public idType: ContactIdKind;

  toAutocompleteValue(consumerType?: 'list' | 'field', culture?: string): string {
    if (consumerType) {
      switch (consumerType) {
        case 'field':
          return this.toString();
        case 'list':
          return `${this.contactCustomerNumber} ${this.contactName} ${this.contactIdentification}`;
      }
    }
  }

  toJSON() {
    return this.id;
  }

  toString() {
    return `${this.contactCustomerNumber} ${this.contactName}`;
  }
}
